var map = {
	"./addliquidity.json": 1188,
	"./box.json": 1189,
	"./components.json": 1190,
	"./constants.json": 1191,
	"./error.json": 1192,
	"./farm.json": 1193,
	"./home.json": 1194,
	"./launchpad.json": 1195,
	"./menu.json": 1196,
	"./minning.json": 1197,
	"./nft.json": 1198,
	"./pool.json": 1199,
	"./referral.json": 1200,
	"./removeliquidity.json": 1201,
	"./rolling.json": 1202,
	"./swap.json": 1203,
	"./team.json": 1204,
	"./uikit.json": 1205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1187;